module.exports = __webpack_public_path__ + "static/img/img-1.94fb478.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-1.png
// module id = sdJb
// module chunks = 1